import React, { useState, useEffect } from "react";
import { updateUserApi, getAvatarApi } from "../../../../api/user";
import { getAccessTokenApi } from "./../../../../api/auth";
import { successModal, warningModal } from '../../../Alerts/Alerts';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import "./EditUserForm.scss";

export default function EditUserForm(props) {
    const { user, setIsVisibleModal, setReloadUsers } = props;
    const [avatar, setAvatar] = useState(null);

    const [userData, setUserData] = useState({});

    useEffect(() => {
        setUserData({
            nombres: user.nombres,
            apellido_paterno: user.apellido_paterno,
            apellido_materno: user.apellido_materno,
            nm_correo: user.nm_correo,
            nm_login: user.nm_login,
            avatar: user.avatar,
            id_perfil: user.id_perfil,
            nm_password: ''
        });
    }, [user]);

    useEffect(() => {
        if(user.avatar) {
            getAvatarApi(user.avatar).then(response => {
                setAvatar(response);
            });
        }else {
            setAvatar(null);
        }
    }, [user]);

    useEffect(() => {
        if(avatar) {
            setUserData({ ...userData, avatar: avatar.file});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [avatar]);

    const updateUser = async e => {
        e.preventDefault();
        const token = getAccessTokenApi();
        let userUpdate = userData;

        if(userUpdate.nm_password || userUpdate.repeatPassword) {
            if (userUpdate.nm_password !== userUpdate.repeatPassword) {
                warningModal("Advertencia", "Las contraseñas tienen que ser iguales.");
                return;
            }else{
                delete userUpdate.repeatPassword;
            }
        }
        
        if (!userUpdate.nombres || !userUpdate.apellido_paterno || !userUpdate.apellido_materno || !userUpdate.nm_correo) {
            warningModal("Advertencia", "El nombre, apellidos y email son obligatorios.");
            return;
        }

        updateUserApi(token, userUpdate, user._id).then(result => {
            setIsVisibleModal(false);
            setReloadUsers(true);
            successModal("",result.message);
        })
    };

    return (
        <div className="edit-user-form">
            <EditForm userData={userData} setUserData={setUserData} updateUser={updateUser} />
        </div>
    );
}

function EditForm(props) {
    const { userData, setUserData, updateUser } = props;

    return (
        <>
            <Form className="form-edit">
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Control 
                                type="text" 
                                name="nombres"
                                placeholder="Nombres" 
                                value={userData.nombres || ''}
                                onChange={e => setUserData({ ...userData, nombres: e.target.value})}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Control 
                                type="text" 
                                name="ap_paterno"
                                placeholder="Apellido Paterno" 
                                value={userData.apellido_paterno || ''}
                                onChange={e => setUserData({ ...userData, apellido_paterno: e.target.value})}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Control 
                                type="text" 
                                name="ap_materno"
                                placeholder="Apellido Materno" 
                                value={userData.apellido_materno || ''}
                                onChange={e => setUserData({ ...userData, apellido_materno: e.target.value})}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col span={24}>
                        <Form.Group>
                            <Form.Control 
                                type="email" 
                                name="correo"
                                placeholder="Correo" 
                                value={userData.nm_correo || ''}
                                onChange={e => setUserData({ ...userData, nm_correo: e.target.value})}
                            />
                        </Form.Group>
                    </Col>
                    
                </Row>

                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Control 
                                type="password" 
                                name="password"
                                placeholder="Contraseña" 
                                onChange={e => setUserData({ ...userData, nm_password: e.target.value})}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                    <Form.Group>
                        <Form.Control 
                            type="password" 
                            name="r_password"
                            placeholder="Repetir Contraseña" 
                            onChange={e => setUserData({ ...userData, repeatPassword: e.target.value})}
                        />
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group>
                    <Button 
                        variant="success" 
                        className="btn-submit" 
                        onClick={updateUser}
                    >
                        Actualizar Usuario
                    </Button>
                </Form.Group>
            </Form>
        </>
    )
}